/** Dictation languages the settings chooser offers, with their native names. */
export const LANGUAGE_OPTIONS = [
    { id: 'en', label: 'English' },
    { id: 'de', label: 'Deutsch' },
    { id: 'nl', label: 'Nederlands' },
    { id: 'es', label: 'Español' },
    { id: 'fr', label: 'Français' },
];
/** Native name by language tag, for surfaces that show the active language. */
export const LANGUAGE_NATIVE_NAMES = Object.fromEntries(LANGUAGE_OPTIONS.map((o) => [o.id, o.label]));
